/**
 * mSTEM SmartHome dashboard mock-data generator (Phase 5 / SMH-02, DR-05).
 *
 * MOCK-ONLY: there is no real sensor, relay, or RFID reader. This module
 * seeds the "Dashboard giám sát thiết bị" modal with a temperature series,
 * a handful of RFID swipe logs, and a couple of threshold alerts, plus a
 * `nextPoint` random-walk used by the dashboard container's 2s tick.
 *
 * `nextPoint` uses Math.random — it is therefore impure and MUST be called
 * from the container's `handleTick` (a React event handler), NEVER from a
 * reducer. The tick caller appends `nextPoint(series)` then `slice(-20)` so
 * the sparkline always shows the last ~20 points (DR-04).
 *
 * GUI-side module (NOT a VM extension) → plain ES exports.
 */

// Seed temperature series (°C) — ~20 points so the sparkline is never empty.
const getInitialSeries = () => [
    24, 25, 25, 26, 27, 26, 27, 28, 29, 28,
    27, 27, 26, 27, 28, 29, 30, 29, 28, 27
];

// Mock RFID swipe logs (6–8 rows). result ∈ 'allow' | 'deny'.
const getRfidLogs = () => [
    {time: '08:01:12', uid: 'A1B2C3D4', result: 'allow'},
    {time: '08:03:47', uid: 'F0E1D2C3', result: 'allow'},
    {time: '08:07:05', uid: '5A6B7C8D', result: 'deny'},
    {time: '08:12:33', uid: '9E8F7A6B', result: 'allow'},
    {time: '08:19:58', uid: '1122AABB', result: 'deny'},
    {time: '08:24:10', uid: 'C3D4E5F6', result: 'allow'},
    {time: '08:31:42', uid: '77889900', result: 'allow'}
];

// Mock threshold alerts (≥2). severity ∈ 'danger' | 'warning'.
const getAlerts = () => [
    {severity: 'danger', text: 'Nhiệt độ 42°C vượt ngưỡng cao'},
    {severity: 'warning', text: 'Độ ẩm 78% gần ngưỡng'},
    {severity: 'warning', text: 'Ánh sáng yếu dưới ngưỡng buổi tối'}
];

// Random-walk: nudge the last value by ±2, clamp to a sane sensor range.
const nextPoint = series => {
    const last = (series && series.length) ? series[series.length - 1] : 27;
    const delta = (Math.random() - 0.5) * 4;
    let next = last + delta;
    if (next < 15) next = 15;
    if (next > 45) next = 45;
    return Math.round(next);
};

export {
    getInitialSeries,
    getRfidLogs,
    getAlerts,
    nextPoint
};
